import http from '@/api/http'

export default {
  gameList () {
    return http.get('/api/channel/auth-game')
  },
  channelList (appId) {
    return http.get(`/api/channel/channel?appId=${appId}`)
  },
  serverList (appId) {
    // return http.get(`/channel/api/app/${appId}/server`)
    // return http.get(`/custom/api/${appId}/servers/0`)
    return http.get(`/cs/${appId}/servers/0`)
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js